import { Component, OnInit, Inject, Input, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {
  FORM_GS,
  FORM_REPSOL,
  POINT_OF_SALE,
  REQUEST_BASIC_CONTACT,
  REQUEST_DATA,
} from '@app/@core/constants/requests.constants';
import { DOWNLOAD, VIEW } from '@app/@core/constants/training.constants';
import { PrintStore } from '@app/@shared/services/print/print.store';
import {
  AuthorizationDTO,
  PrintContractDTO,
  RequestDataReponseDTO,
  AuthorizationPapyrusDTO,
  RequestFormDTO,
} from '@app/requests/model/requests-model';
import { RequestsSaveSendStore } from '@app/requests/requests-save-send-service/requests-save-send.store';
import { ResponseDialogComponent } from '../response/response-dialog.component';
import { RequestsSaveSendApi } from '@app/requests/requests-save-send-service/requests-save-send-api.service';
import { FORM_CONSUMO, BRAND_AUTOS, BRAND_PAPYRUS_CONSUMO } from '@core/constants/requests.constants';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-password-dialog',
  templateUrl: './password-dialog.component.html',
  styleUrls: ['./password-dialog.component.scss'],
})
export class PaswordDialogComponent implements OnInit {
  @Input() typeRequest: string;

  public passwordForm: FormGroup;
  checked: boolean = false;
  type: string;
  request_type: string;
  downloadAuthorization: true;
  typeLinkSelected: string;
  showTypelink: number = 0;
  isAuto: boolean = false;
  request: any;
  operative: string;
  mode: string;

  constructor(
    private formBuilder: FormBuilder,
    private dialogRef: MatDialogRef<PaswordDialogComponent>,
    private saveSendApi: RequestsSaveSendApi,
    private requestStore: RequestsSaveSendStore,
    private cdref: ChangeDetectorRef,
    private printStore: PrintStore,
    private datePipe: DatePipe,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    console.log(data);
    this.type = data.type;
    this.request_type = data.request_type;
    this.isAuto = data.isAuto;
    this.request = data.request;
    this.operative = data.operative;
    this.mode = data.mode;
  }

  ngOnInit(): void {
    if (this.type === 'save_rack' || this.type === 'EIC') {
      if (this.type === 'save_rack') {
        this.passwordForm = this.formBuilder.group({
          password: ['', Validators.required],
        });
      } else if (this.type === 'EIC') {
        this.passwordForm = this.formBuilder.group({
          typeLink: ['', Validators.required],
        });
      }
    } else {
      if (this.type != 'EIC') {
        this.passwordForm = this.formBuilder.group({
          password: ['', Validators.required],
          checkObservations: [false, Validators.requiredTrue],
        });
      } else {
        this.passwordForm = this.formBuilder.group({
          password: [''],
          checkObservations: [false],
        });
      }
    }

    if (
      this.requestStore.listaFormulariosConsumo[REQUEST_BASIC_CONTACT]?.controls.telephone.value.length > 0 &&
      this.requestStore.listaFormulariosConsumo[REQUEST_BASIC_CONTACT]?.controls.email.value.length > 0
    ) {
      this.showTypelink = 0;
      this.typeLinkSelected = 'SMS';
    } else if (this.requestStore.listaFormulariosConsumo[REQUEST_BASIC_CONTACT]?.controls.telephone.value.length > 0) {
      this.showTypelink = 1;
      this.typeLinkSelected = 'SMS';
    } else {
      this.showTypelink = 2;
      this.typeLinkSelected = 'email';
    }

    this.passwordForm.updateValueAndValidity();
    this.cdref.detectChanges();
  }

  download() {
    if (this.passwordForm.valid) {
      if (
        this.isAuto ||
        this.request_type === FORM_CONSUMO ||
        this.request_type === FORM_GS ||
        this.request_type === FORM_REPSOL
      ) {
        let RequestFormDTO: RequestFormDTO;

        RequestFormDTO = this.requestStore.convertFormToRequestFormDTO(this.request_type, {
          password: this.passwordForm.controls.password.value,
          autoriza: this.passwordForm.controls.checkObservations.value,
        });

        this.requestStore.downloadPapyrus(
          this.isAuto,
          this.mode,
          RequestFormDTO,
          RequestFormDTO?.operative?.code,
          this.request_type,
          null,
          this.passwordForm
        );
      } else {
        let RequestFormDTO: RequestFormDTO;
        let RequestAuthorization: AuthorizationDTO;

        RequestFormDTO = this.requestStore.convertFormToRequestFormDTO(this.request_type, {
          password: this.passwordForm.controls.password.value,
          autoriza: this.passwordForm.controls.checkObservations.value,
        });
        console.log('download', RequestFormDTO);
        RequestAuthorization = this.printStore.convertAuthorizationToHolderDTO(RequestFormDTO, false);

        if (RequestAuthorization) {
          this.printStore.downloadAuthorization(RequestAuthorization, DOWNLOAD);
        }
      }
    }
  }

  sendToPrintAuth(requestDTO: RequestFormDTO, numOperation: string) {
    let coBrand: string;
    this.isAuto ? (coBrand = 'AUTOS') : (coBrand = 'MANGO');

    let printContract: PrintContractDTO = {
      bindOffer: 'N',
      coBrand: coBrand,
      codeOperative: this.operative,
      codeProduct: requestDTO.financialProduct,
      dateEntry: requestDTO.dateRequest,
      isIne: 'S',
      language: requestDTO.language,
      notary: '',
      numOperation: numOperation,
      versionContract: '',
      versionPolicy: '',
      authorization: 'S',
    };

    this.printStore.printContract(printContract).then(
      (data) => {
        if (data) {
          this.printStore.openPDFOnSuccess(
            data,
            numOperation,
            requestDTO.language,
            '',
            printContract,
            requestDTO.documentId
          );
        }
      },
      (error) => {
        console.log('error print: ', error);
        const dialogConfig = new MatDialogConfig();
        dialogConfig.width = '90%';
        dialogConfig.maxWidth = '450px';
        dialogConfig.data = { text: error, icon: 'icon-ic_circle_cross' };
        this.dialog.open(ResponseDialogComponent, dialogConfig);
      }
    );
  }

  onclick() {
    console.log(this.checked);
  }

  accept(): void {
    let autorizacion: string;
    if (this.type == 'save_rack' || this.passwordForm.controls.checkObservations?.value) {
      autorizacion = 'S';
    } else {
      autorizacion = 'N';
    }
    this.dialogRef.close({
      password: this.type === 'EIC' ? '' : this.passwordForm.controls.password.value,
      autoriza: autorizacion,
      typeLink: this.typeLinkSelected,
    });
  }

  exit(): void {
    this.dialogRef.close();
  }
}
